import gql from "graphql-tag";

export const mutationSubscribeToPlan = gql`
    mutation subscribeToPlan($plan: Int!, $delayed: Boolean) {
        subscribeToPlan(plan: $plan, delayed: $delayed)
    }
`;
